import { Component, Input } from '@angular/core';
import { LandingPageSection } from 'src/app/landing-page.model';

@Component({
  selector: 'app-page-gallery',
  templateUrl: './page-gallery.component.html',
  styleUrls: ['./page-gallery.component.scss']
})
export class PageGalleryComponent {
  @Input() data: LandingPageSection;
  @Input() desktopWidth: string = "1110";
  constructor() { }

}
